import React from 'react'
import styled from '@emotion/styled'
import { generate } from 'shortid'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import ArrowBack from '@mui/icons-material/ArrowBack'
import ArrowForward from '@mui/icons-material/ArrowForward'
import PlusOne from '@mui/icons-material/PlusOne'
import { Map } from '../Common'

const LegContainer = styled('div')(({ theme }) => ({
  fontSize: '.75em',
  width: '100%',
  color: theme.palette.primary.main,
  gridArea: '1 / 2 / 2 / 4',
}))

const LegBorderStyle = styled('div')(({ theme }) => ({
  boxShadow: '0 2px 5px rgba(0,0,0,0.16), 0 2px 5px rgba(0,0,0,0.23)',
  borderBlockColor: theme.palette.primary.main,
  borderRadius: '3px',
  borderWidth: '1px',
  borderStyle: 'solid',
  height: '100%',
  padding: '1rem',
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr) 2fr',
  gridTemplateRows: 'repeat(4, 1fr)',
  gridColumnGap: '20px',
  gridRowGap: '20px',
}))

const MapContainer = styled('div')(({ theme }) => ({
  boxShadow: '0 2px 5px rgba(0,0,0,0.16), 0 2px 5px rgba(0,0,0,0.23)',
  height: '100%',
  padding: '1rem',
  gridArea: '1 / 3 / 5 / 5',
}))

const InputStyle = styled(TextField)({
  width: '100%',
  marginTop: '.5rem',
  '& div': {
    height: '40px',
  },
})

const TitleContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
})

const AddLegStyled = styled(Typography)({
  marginLeft: '.5rem',
})

function Leg({ setLegs, selectedLeg, setSelectedLeg, legs }) {
  const currentIndex = selectedLeg.number - 1
  const handleNext = () => {
    if (selectedLeg.number < legs.length) {
      setSelectedLeg(legs[currentIndex + 1])
    }
  }

  const handleBack = () => {
    if (currentIndex > 0) {
      setSelectedLeg(legs[currentIndex - 1])
    }
  }

  const handleNewLeg = () => {
    const newLegs = [
      ...legs,
      {
        id: generate(),
        number: legs.length + 1,
      },
    ]
    setLegs(newLegs)
    setSelectedLeg(newLegs[newLegs.length - 1])
  }

  return (
    <LegContainer>
      <TitleContainer>
        <h1>{`Itinerary - Leg ${selectedLeg.number}`}</h1>
        <IconButton onClick={handleBack}>
          <ArrowBack color="secondary" />
        </IconButton>
        <IconButton onClick={handleNext}>
          <ArrowForward color="secondary" />
        </IconButton>
        <IconButton onClick={handleNewLeg}>
          <PlusOne color="primary" />
          <AddLegStyled>Add Leg</AddLegStyled>
        </IconButton>
      </TitleContainer>
      <LegBorderStyle>
        <InputStyle
          id="departure-date"
          label="Departure Date*"
          variant="outlined"
          type="date"
          focused
        />
        <InputStyle
          id="arrival-airport"
          label="Arrival Airport*"
          variant="outlined"
          focused
        />
        <InputStyle id="ete" label="ETE*" variant="outlined" focused />
        <InputStyle
          id="departure-airport"
          label="Departure Airport*"
          variant="outlined"
          focused
        />
        <InputStyle
          id="etd-local-time"
          label="ETD Local Time*"
          variant="outlined"
          focused
        />
        <InputStyle
          id="eta-zulu-time"
          label="ETA Zulu Time*"
          variant="outlined"
          focused
        />
        <InputStyle
          id="etd-zulu-time"
          label="ETD Zulu Time*"
          variant="outlined"
          focused
        />
        <InputStyle
          id="eta-local-time"
          label="ETA Local Time*"
          variant="outlined"
          focused
        />
        <MapContainer>
          <Map
            latitude={60}
            latitudeDirection="N"
            longitude={20}
            longitudeDirection="E"
          />
        </MapContainer>
      </LegBorderStyle>
    </LegContainer>
  )
}

export default Leg
